<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiChevronRightCircleOutline } from "@mdi/js";
export default {
  name: "MdiChevronRightCircleOutline",
  data() {
    return {
      svgPath: mdiChevronRightCircleOutline,
    };
  },
};
</script>
